'use strict';

import React from 'react';
import {Link} from 'react-router';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import ProduceStore from "../../stores/ProduceStore";
import Bills from "./Bills";
const styles = {
    width: 120
};

let packagingOptions = [];

class Available extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allProduce: [],
            filterProduce: [],
            max: -1,
            packaging:"KG",
            searchText:""
        };
        this.updateProduce = this.updateProduce.bind(this);
        this.getPackaging = this.getPackaging.bind(this);
        this.updatePackaging = this.updatePackaging.bind(this);
        this.searchProduceFilter = this.searchProduceFilter.bind(this);



    }


    searchProduceFilter(text) {
        // var searchName = $("#searchaFarmer").val().trim();
        // if(searchName==""|| searchName==null){
        //     processSearchFarmer(searchFarmersData);
        //     return;
        // }

        if (text.toLowerCase() == "") {
            this.setState({
                filterProduce:this.state.allProduce,
                searchText:"",
            })
            return;
        }
        text=text.toLowerCase()
        let show= this.state.allProduce.filter(function (item) {
            return item.name.toLowerCase().includes(text);
        })
        this.setState({
            searchText:text,
            filterProduce:show
        })
        console.log(show)

        // console.log(show)
        // this.setState({
        //     searchText:text
        // },function () {
        //     let  show =
        //     self.setState({
        //         filterProduce:show
        //     })
        // })

        // console.log(show);
        // return show;
        // processSearchFarmer(show);
    }

    updatePackaging(packaging,produce){
        console.log(produce)
        produce.displayPrice=packaging=="KG"?produce.price:produce.packagingPrice
        this.setState({
            packaging:packaging
        })
    }

    componentWillMount() {
        this.setState({
            allProduce: ProduceStore.getInventoryData(),
        });
        ProduceStore.on("change", this.updateProduce);
        Connections.getProduceListView();
    }

    updateProduce() {

        this.setState({
            allProduce: ProduceStore.getInventoryData(),
            filterProduce: ProduceStore.getInventoryData(),
        });
    }

    getImageName(imageName) {
        return Connections.getProduceImageLink() + imageName.replace(" ", "").toLowerCase() + ".jpg";
    }

    getPackaging(data) {
        packagingOptions = data.packaging.split(',');
        return packagingOptions;
    }

    render() {
        return (
            <DocumentTitle title="Khula - Available Orders">
                <div className="main-content">

                    <div className="filter-bar">


                        <input type="Search" name="search" value={this.state.searchText} width="10%" placeholder="Search..." onChange={(e)=>{
                            this.searchProduceFilter(e.target.value)
                        }}/>

                        {/*<p>Organic</p>*/}

                        {/*<label className="switch">*/}
                        {/*<input type="checkbox"/>*/}
                        {/*<span className="slider round"></span>*/}
                        {/*</label>*/}
                        {/*<p>Favourites</p>*/}
                        {/*<label className="switch">*/}
                        {/*<input type="checkbox"/>*/}
                        {/*<span className="slider round"></span>*/}
                        {/*</label>*/}
                        {/*<p>Veg</p>*/}
                        {/*<label className="switch">*/}
                        {/*<input type="checkbox"/>*/}
                        {/*<span className="slider round"></span>*/}
                        {/*</label>*/}
                        {/*<p>Fruit</p>*/}
                        {/*<label className="switch">*/}
                        {/*<input type="checkbox"/>*/}
                        {/*<span className="slider round"></span>*/}
                        {/*</label>*/}
                        {/*<p>Herbs</p>*/}
                        {/*<label className="switch">*/}
                        {/*<input type="checkbox"/>*/}
                        {/*<span className="slider round"></span>*/}
                        {/*</label>*/}

                    </div>

                    <div className="uk-overflow-auto">
                        <div class="uk-grid-small uk-flex-row uk-text-center">


                            <div className="marketmain">
                                {this.state.filterProduce.map((produce, i) =>

                                    <div className="produce-market-container">

                                        <div className="produce-container-image">
                                            <img alt="" src={this.getImageName(produce.name)}/>
                                        </div>

                                        <div className="produce-container-content">
                                            <h6><b>{produce.name}</b></h6>
                                            <h6><b>P:</b> R{produce.displayPrice} <br/>
                                                <b>Q:</b> {produce.quantity} KG <br/> View farmers </h6>
                                        </div>

                                        <div className="packagingoptions">

                                            <form>
                                                <input type="radio" name="gender"
                                                       value="male" onClick={()=>this.updatePackaging("KG",produce)}/> KG
                                                {produce.packaging&& <input type="radio" name="gender"
                                                                            value="male" onClick={() => this.updatePackaging(produce.packaging,produce)}/>}{produce.packaging}


                                            </form>

                                        </div>

                                        <div className=" produce-container-button">
                                            <button
                                                onClick={() => this.props.self().handleOpenExternal(produce.name, this.state.packaging=="KG"?produce.price:produce.packagingPrice, this.getImageName(produce.name),
                                                    this.state.packaging)}
                                                className="buttonbuy"><img
                                                src="https://client.khula.co.za/images/cart.png"/> Buy Now
                                            </button>
                                            <button
                                                onClick={() => this.props.self().handleOpenExternal(produce.name, this.state.packaging=="KG"?produce.price:produce.packagingPrice, this.getImageName(produce.name),
                                                    this.state.packaging)}
                                                className="buttonbid"><img
                                                src="https://client.khula.co.za/images/cart.png"/> Bid
                                            </button>

                                        </div>

                                    </div>
                                )};
                            </div>
                        </div>
                    </div>


                    {/*<div className="cart-slider">*/}
                    {/*<div className="cart-heading">*/}

                    {/*<h3> <img src="https://client.khula.co.za/images/goods.png"/>  My Cart</h3>*/}
                    {/*</div>*/}
                    {/*<div className="cart-body">*/}
                    {/*<div className="checkout-product">*/}
                    {/*<div className="checkout-product-image">*/}
                    {/*<img src="https://client.khula.co.za/images/chives.jpg"/>*/}
                    {/*</div>*/}
                    {/*<div className="checkout-product-content">*/}
                    {/*<h5>Chives</h5>*/}
                    {/*<p>P:R7  |   Q:450</p>*/}
                    {/*</div>*/}
                    {/*<div className="editdelete">*/}
                    {/*<p>Edit</p>*/}
                    {/*<p>Delete</p>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    {/*<div className="checkoutbutton">*/}
                    {/*<button>Checkout</button>*/}
                    {/*</div>*/}
                    {/*</div>*/}


                </div>
            </DocumentTitle>
        );
    }

}


export default Available;


// WEBPACK FOOTER //
// ./src/pages/HopePageBabies/Available.js